import React from 'react'
import { graphql } from 'gatsby'
import { Offer } from '../mapper'
import Tag from './Tag'

export type EssentialsInfosProps = {
  data: Offer
  color?: string
  bgColor?: string
}

const EssentialsInfos: React.FC<EssentialsInfosProps> = ({
  data,
  color = 'primary',
  bgColor = 'primary',
}) => {
  if (!data) {
    return null
  }

  return (
    <div className="container flex flex-col items-center gap-3 p-4 mx-auto lg:items-start">
      <div className="flex gap-2">
        <Tag info={data.contractType} color={color} bgColor={bgColor} />
        <Tag
          info={data.experienceRequirement}
          color={color}
          bgColor={bgColor}
        />
      </div>
      <div className="flex gap-2">
        <Tag info={data.fullyRemoteJob} color={color} bgColor={bgColor} />
      </div>
      <div className="flex gap-2">
        <Tag info={data.payRange} color={color} bgColor={bgColor} />
        <Tag info={data.educationRequirement} color={color} bgColor={bgColor} />
      </div>
      <div className="flex gap-2">
        <Tag info={data.startDate} color={color} bgColor={bgColor} />
        <Tag info={data.hoursPerWeek} color={color} bgColor={bgColor} />
      </div>
    </div>
  )
}

export default EssentialsInfos

export const query = graphql`
  fragment OfferEssentialsInfos on STRAPI_ACCOUNTING_OFFER {
    contractType
    educationRequirement
    experienceRequirement
    startDate(locale: "")
    payRange {
      min
      max
    }
  }
`
